import React from 'react'
import Link from 'gatsby-link'
import stickNSlide from 'stick-n-slide';
import 'stick-n-slide/dist/index.css';

function randomColor() {
  return '#' + (Math.random()*0xFFFFFF<<0).toString(16);
}

function randomNumber() {
  return Math.floor(Math.random() * 6) + 1;
}

function backgroundColor(event) {
  event.target.style.backgroundColor = randomColor();
}

function borderColor(event) {
  event.target.style.borderColor = randomColor();
}

class Demo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cell: undefined,
    };
    this.changeBgColor = this.changeBgColor.bind(this);
    this.changeContent = this.changeContent.bind(this);
    this.mergeCell = this.mergeCell.bind(this);

    this.changeBorderColor = this.changeBorderColor.bind(this);
    this.changeBorderWidth = this.changeBorderWidth.bind(this);

    this.setCell = this.setCell.bind(this);
  }

  changeBgColor() {
    this.state.cell.style.backgroundColor = randomColor();
  }
  changeBorderColor() {
    this.state.cell.style.borderColor = randomColor();
  }
  changeBorderWidth() {
    this.state.cell.style.borderWidth = `${randomNumber()}px`
  }
  changeContent() {
    fetch('http://www.randomtext.me/api/lorem/p-1/5-15')
      .then(response => response.json())
      .then((json) => {
        this.state.cell.innerHTML = json.text_out;
      });
  }

  mergeCell() {
    if (this.state.cell.nextElementSibling) {
      this.state.cell.colSpan = this.state.cell.colSpan + this.state.cell.nextElementSibling.colSpan;
      this.state.cell.nextElementSibling.remove();
    }
  }

  setCell(event) {
    const target = event.target;
    if (event.target.tagName === 'TH' || event.target.tagName === 'TD') {
      this.setState(() => {
        return {cell: target};
      });
    }
  }

  componentDidMount() {
    const table = document.querySelector('table');

    // table.querySelectorAll('th, td').forEach((cell) => {

    //   cell.onClick = this.setCell;
    // });


    Array.prototype.slice.call(table.querySelectorAll('thead th:nth-child(-n+3)')).forEach((th) => {
      th.classList.add('sns--is-stuck');
    });

    Array.prototype.slice.call(table.querySelectorAll('thead th:nth-child(n+4)')).forEach((th) => {
      th.classList.add('sns--is-stuck-y');
    });

    Array.prototype.slice.call(table.querySelectorAll('tbody > tr:nth-child(n):nth-child(-n+11) > *:nth-child(-n+3)')).forEach((cell) => {
      cell.classList.add('sns--is-stuck-x');
    });

    Array.prototype.slice.call(table.querySelectorAll('tbody > tr:nth-child(12) > *:nth-child(-n+2)')).forEach((cell) => {
      cell.classList.add('sns--is-stuck-x');
    });

    Array.prototype.slice.call(table.querySelectorAll('tbody > tr:nth-child(13) > *:nth-child(-n+1)')).forEach((cell) => {
      cell.classList.add('sns--is-stuck-x');
    });

    stickNSlide(table, {showShadow: true});

    this.setState(() => {
      return {cell: table.querySelector('th')}
    });
  }
  render () {
    return(
      <div className="demo">
        <h2>Demo</h2>
        <div>
          <div className="wrapper">
            <table onClick={this.setCell}>
              <thead>
                <tr>
                  <th>A1</th>
                  <th>A2</th>
                  <th>A3</th>
                  <th>A4</th>
                  <th>A5</th>
                  <th>A6</th>
                  <th>A7</th>
                  <th>A8</th>
                  <th>A9</th>
                  <th>A10</th>
                  <th>A11</th>
                  <th>A12</th>
                  <th>A13</th>
                  <th>A14</th>
                  <th>A15</th>
                  <th>A16</th>
                  <th>A17</th>
                  <th>A18</th>
                  <th>A19</th>
                  <th>A20</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>B1</td>
                  <td>B2</td>
                  <td>B3</td>
                  <td>B4</td>
                  <td>B5</td>
                  <td>B6</td>
                  <td>B7</td>
                  <td>B8</td>
                  <td>B9</td>
                  <td>B10</td>
                  <td>B11</td>
                  <td>B12</td>
                  <td>B13</td>
                  <td>B14</td>
                  <td>B15</td>
                  <td>B16</td>
                  <td>B17</td>
                  <td>B18</td>
                  <td>B19</td>
                  <td>B20</td>
                </tr>
                <tr>
                  <td>C1</td>
                  <td>C2</td>
                  <td>C3</td>
                  <td>C4</td>
                  <td>C5</td>
                  <td>C6</td>
                  <td>C7</td>
                  <td>C8</td>
                  <td>C9</td>
                  <td>C10</td>
                  <td>C11</td>
                  <td>C12</td>
                  <td>C13</td>
                  <td>C14</td>
                  <td>C15</td>
                  <td>C16</td>
                  <td>C17</td>
                  <td>C18</td>
                  <td>C19</td>
                  <td>C20</td>
                </tr>
                <tr>
                  <td>D1</td>
                  <td>D2</td>
                  <td>D3</td>
                  <td>D4</td>
                  <td>D5</td>
                  <td>D6</td>
                  <td>D7</td>
                  <td>D8</td>
                  <td>D9</td>
                  <td>D10</td>
                  <td>D11</td>
                  <td>D12</td>
                  <td>D13</td>
                  <td>D14</td>
                  <td>D15</td>
                  <td>D16</td>
                  <td>D17</td>
                  <td>D18</td>
                  <td>D19</td>
                  <td>D20</td>
                </tr>
                <tr>
                  <td>E1</td>
                  <td>E2</td>
                  <td>E3</td>
                  <td>E4</td>
                  <td>E5</td>
                  <td>E6</td>
                  <td>E7</td>
                  <td>E8</td>
                  <td>E9</td>
                  <td>E10</td>
                  <td>E11</td>
                  <td>E12</td>
                  <td>E13</td>
                  <td>E14</td>
                  <td>E15</td>
                  <td>E16</td>
                  <td>E17</td>
                  <td>E18</td>
                  <td>E19</td>
                  <td>E20</td>
                </tr>
                <tr>
                  <td>F1</td>
                  <td>F2</td>
                  <td>F3</td>
                  <td>F4</td>
                  <td>F5</td>
                  <td>F6</td>
                  <td>F7</td>
                  <td>F8</td>
                  <td>F9</td>
                  <td>F10</td>
                  <td>F11</td>
                  <td>F12</td>
                  <td>F13</td>
                  <td>F14</td>
                  <td>F15</td>
                  <td>F16</td>
                  <td>F17</td>
                  <td>F18</td>
                  <td>F19</td>
                  <td>F20</td>
                </tr>
                <tr>
                  <td>G1</td>
                  <td>G2</td>
                  <td>G3</td>
                  <td>G4</td>
                  <td>G5</td>
                  <td>G6</td>
                  <td>G7</td>
                  <td>G8</td>
                  <td>G9</td>
                  <td>G10</td>
                  <td>G11</td>
                  <td>G12</td>
                  <td>G13</td>
                  <td>G14</td>
                  <td>G15</td>
                  <td>G16</td>
                  <td>G17</td>
                  <td>G18</td>
                  <td>G19</td>
                  <td>G20</td>
                </tr>
                <tr>
                  <td>H1</td>
                  <td>H2</td>
                  <td>H3</td>
                  <td>H4</td>
                  <td>H5</td>
                  <td>H6</td>
                  <td>H7</td>
                  <td>H8</td>
                  <td>H9</td>
                  <td>H10</td>
                  <td>H11</td>
                  <td>H12</td>
                  <td>H13</td>
                  <td>H14</td>
                  <td>H15</td>
                  <td>H16</td>
                  <td>H17</td>
                  <td>H18</td>
                  <td>H19</td>
                  <td>H20</td>
                </tr>
                <tr>
                  <td>I1</td>
                  <td>I2</td>
                  <td>I3</td>
                  <td>I4</td>
                  <td>I5</td>
                  <td>I6</td>
                  <td>I7</td>
                  <td>I8</td>
                  <td>I9</td>
                  <td>I10</td>
                  <td>I11</td>
                  <td>I12</td>
                  <td>I13</td>
                  <td>I14</td>
                  <td>I15</td>
                  <td>I16</td>
                  <td>I17</td>
                  <td>I18</td>
                  <td>I19</td>
                  <td>I20</td>
                </tr>
                <tr>
                  <td>J1</td>
                  <td>J2</td>
                  <td>J3</td>
                  <td>J4</td>
                  <td>J5</td>
                  <td>J6</td>
                  <td>J7</td>
                  <td>J8</td>
                  <td>J9</td>
                  <td>J10</td>
                  <td>J11</td>
                  <td>J12</td>
                  <td>J13</td>
                  <td>J14</td>
                  <td>J15</td>
                  <td>J16</td>
                  <td>J17</td>
                  <td>J18</td>
                  <td>J19</td>
                  <td>J20</td>
                </tr>
                <tr>
                  <td>K1</td>
                  <td>K2</td>
                  <td>K3</td>
                  <td>K4</td>
                  <td>K5</td>
                  <td>K6</td>
                  <td>K7</td>
                  <td>K8</td>
                  <td>K9</td>
                  <td>K10</td>
                  <td>K11</td>
                  <td>K12</td>
                  <td>K13</td>
                  <td>K14</td>
                  <td>K15</td>
                  <td>K16</td>
                  <td>K17</td>
                  <td>K18</td>
                  <td>K19</td>
                  <td>K20</td>
                </tr>
                <tr>
                  <td>L1</td>
                  <td>L2</td>
                  <td>L3</td>
                  <td>L4</td>
                  <td>L5</td>
                  <td>L6</td>
                  <td>L7</td>
                  <td>L8</td>
                  <td>L9</td>
                  <td>L10</td>
                  <td>L11</td>
                  <td>L12</td>
                  <td>L13</td>
                  <td>L14</td>
                  <td>L15</td>
                  <td>L16</td>
                  <td>L17</td>
                  <td>L18</td>
                  <td>L19</td>
                  <td>L20</td>
                </tr>
                <tr>
                  <td>M1</td>
                  <td>M2</td>
                  <td>M3</td>
                  <td>M4</td>
                  <td>M5</td>
                  <td>M6</td>
                  <td>M7</td>
                  <td>M8</td>
                  <td>M9</td>
                  <td>M10</td>
                  <td>M11</td>
                  <td>M12</td>
                  <td>M13</td>
                  <td>M14</td>
                  <td>M15</td>
                  <td>M16</td>
                  <td>M17</td>
                  <td>M18</td>
                  <td>M19</td>
                  <td>M20</td>
                </tr>
                <tr>
                  <td>N1</td>
                  <td>N2</td>
                  <td>N3</td>
                  <td>N4</td>
                  <td>N5</td>
                  <td>N6</td>
                  <td>N7</td>
                  <td>N8</td>
                  <td>N9</td>
                  <td>N10</td>
                  <td>N11</td>
                  <td>N12</td>
                  <td>N13</td>
                  <td>N14</td>
                  <td>N15</td>
                  <td>N16</td>
                  <td>N17</td>
                  <td>N18</td>
                  <td>N19</td>
                  <td>N20</td>
                </tr>
                <tr>
                  <td>O1</td>
                  <td>O2</td>
                  <td>O3</td>
                  <td>O4</td>
                  <td>O5</td>
                  <td>O6</td>
                  <td>O7</td>
                  <td>O8</td>
                  <td>O9</td>
                  <td>O10</td>
                  <td>O11</td>
                  <td>O12</td>
                  <td>O13</td>
                  <td>O14</td>
                  <td>O15</td>
                  <td>O16</td>
                  <td>O17</td>
                  <td>O18</td>
                  <td>O19</td>
                  <td>O20</td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>

          <p>Click on one of the cells in the above table, and then click one of the buttons below. You'll see that almost all native table functionality works automatically with Stick-n-Slide, including the ability to have colspan/rowspan on cells, as well as having cells grow and shrink automatically with their contents.</p>
          <div>
            <h4 hidden>Safe functions</h4>
            <button onClick={this.changeBgColor}>Change background</button> <button onClick={this.mergeCell}>Merge cell with next</button> <button onClick={this.changeContent}>Change content</button>
            
            {
              /*
            <h4>Unsafe functions</h4>
            <button onClick={this.changeBorderColor}>Change border color</button> <button onClick={this.changeBorderWidth}>Change border width</button>

              */
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Demo





// WEBPACK FOOTER //
// ./src/components/stick-n-slide/demo.jsx